import {Component, Input, OnInit} from '@angular/core';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {take} from 'rxjs/operators';
import {ShortcutItem} from '@features/file-manager/models/file-manager.model';
import {Router} from '@angular/router';
import {FileStoreCommonService} from '@features/file-manager/services/file-store-common.service';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {select, Store} from '@ngrx/store';
import {getBreadCrumbs, ParticleState} from '@shared/store/reducers/particle.reduer';


@Component({
    standalone: false,
    selector: 'app-file-store-short-cut',
  templateUrl: './file-store-short-cut.component.html',
  styleUrls: ['./file-store-short-cut.component.scss']
})
export class FileStoreShortCutComponent implements OnInit {
  @Input() isClientDrive: boolean;
  @Input() shortcutTags: string[] = [];
  @Input() shortCuts: any;
  public isReady: boolean;
  breadcrumbs: BreadcrumbModel[];

  constructor(private platformQueryService: PlatformQueryService,
              private router: Router,
              private fileStoreCommonService: FileStoreCommonService,
              private particleStore: Store<ParticleState>) {
  }

  ngOnInit(): void {
    this.getShortcut();
    this.particleStore.pipe(select(getBreadCrumbs)).subscribe(res => this.breadcrumbs = res);
  }

  onclickItem(shortcutItem: ShortcutItem) {
    console.log('[ShortcutItem]', shortcutItem);
    const command = shortcutItem.command;
    command.fieldValues['ViewType'] = command.fieldValues['ViewType'] ?? 'IconView';
    command.fieldValues['ParentId'] = shortcutItem.id;
    this.fileStoreCommonService.executeCommand(command);
  }

  private getShortcut() {
    if (this.shortCuts && this.shortCuts.length  && this.shortCuts.length> 0) {
      return;
    }
    const query = new PlatformQuery();
    query.name = 'DriveShortCutsQuery';
    query.api = 'FileStoreApi';
    query.isCamelCase = true;
    query.fieldValues['IsClientDrive'] = this.isClientDrive;
    query.fieldValues['Tag'] = this.shortcutTags[0];
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      this.shortCuts = response.fieldValues['ShortCutsList'];
      this.isReady = !!this.shortCuts;
    });
  }
}
